import { $, $$ } from '@/utilities/helpers';
import { API } from '@/utilities/api';
import Swal from 'sweetalert2/dist/sweetalert2.js'

const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast',
    },
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
})

let $notes = $('.js-notes');
let $$showNotes = $$('.js-show-notes');
let $$hideNotes = $$('.js-hide-notes');

let entity_id = document.body.dataset.keepEntityId;
let entity_type = document.body.dataset.keepEntityType;

let $actionButton = $('.js-action-button');
let $actionButtonToggle = $('.js-action-button-toggle');

if ($actionButton) {
    setTimeout(() => {
        $actionButton.classList.add('visible');
    }, 100);

    $actionButtonToggle.addEventListener('click', (e) => {
        e.preventDefault();
        $actionButton.classList.toggle('active');
    });

    let $$hearts = $$('.js-toggle-item-from-keeps');

    if ($$hearts) {
        $$hearts.forEach($heart => {
            $heart.addEventListener('click', (e) => {
                e.preventDefault();

                if ($('.js-toggle-item-from-keeps-breadcrumbs')) $('.js-toggle-item-from-keeps-breadcrumbs').classList.toggle('hearted');

                $heart.classList.toggle('hearted');

                API.toggle_favourites({ entity_id, entity_type })
                    .then((response) => {

                        if (response.status !== 'ok' || response.message === 401) {
                            $heart.classList.toggle('hearted');
                        }

                        // Toast.fire({
                        //     icon: (response.status === 'ok') ? 'success' : 'error',
                        //     title: (response.message !== 401) ? response.message : 'You need to be logged in as a pro member to favourite pages'
                        // });
                    });

            });
        });
    }

    let $$heartsBreadcrumbs = $$('.js-toggle-item-from-keeps-breadcrumbs');

    if ($$heartsBreadcrumbs) {
        $$heartsBreadcrumbs.forEach($heartBreadcrumbs => {
            $heartBreadcrumbs.addEventListener('click', (e) => {
                e.preventDefault();

                if ($('.js-toggle-item-from-keeps')) $('.js-toggle-item-from-keeps').classList.toggle('hearted');

                $heartBreadcrumbs.classList.toggle('hearted');

                API.toggle_favourites({ entity_id, entity_type })
                    .then((response) => {

                        if (response.status !== 'ok' || response.message === 401) {
                            $heartBreadcrumbs.classList.toggle('hearted');
                        }

                        // Toast.fire({
                        //     icon: (response.status === 'ok') ? 'success' : 'error',
                        //     title: (response.message !== 401) ? response.message : 'You need to be logged in as a pro member to favourite pages'
                        // });
                    });

            });
        });
    }

    let timeAgo = (date) => {

        const now = new Date();
        const seconds = Math.floor((now - new Date(date)) / 1000);

        let interval = Math.floor(seconds / 31536000);
        if (interval > 1) return `${interval} years ago`;

        interval = Math.floor(seconds / 2592000);
        if (interval > 1) return `${interval} months ago`;

        interval = Math.floor(seconds / 86400);
        if (interval > 1) return `${interval} days ago`;

        interval = Math.floor(seconds / 3600);
        if (interval > 1) return `${interval} hours ago`;

        interval = Math.floor(seconds / 60);
        if (interval > 1) return `${interval} minutes ago`;

        return `under a minute ago`;
    }


    let renderNotes = (notes) => {

        let $notesList = $notes.querySelector('.js-notes-list');

        if (notes.length === 0) {
            $notesList.innerHTML = '<p>You do not have any notes added to this page yet</p>';
        } else {
            $notesList.innerHTML = '';
            let notesHTML = '';
            notes.forEach(note => {
                notesHTML += /*html*/`
            <div class="notes__item [ js-note ]" data-id="${note.keep_id}" data-entity-id="${note.entity_id}" data-type="${note.entity_type}">
                <div class="notes__content">
                    <p class="no-margin [ js-note-content ]">${note.content}</p>
                    <p class="notes__content__date"><b>${timeAgo(note.created)}</b></p>
                </div>
                <a href="#" class="notes__update [ js-update-note ]" data-keep-id="$ID">
                    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000">
                        <path d="M228.31-164q-27.01 0-45.66-18.65Q164-201.3 164-228.31v-503.38q0-27.01 18.65-45.66Q201.3-796 228.31-796h408.3q12.69 0 24.42 4.62 11.74 4.61 21.58 14.46l94.31 94.31q9.85 9.84 14.46 21.58Q796-649.3 796-636.61v408.3q0 27.01-18.65 45.66Q758.7-164 731.69-164H228.31ZM744-642 642-744H228.31q-5.39 0-8.85 3.46t-3.46 8.85v503.38q0 5.39 3.46 8.85t8.85 3.46h503.38q5.39 0 8.85-3.46t3.46-8.85V-642ZM480-281.23q36.54 0 62.27-25.73Q568-332.69 568-369.23q0-36.54-25.73-62.27-25.73-25.73-62.27-25.73-36.54 0-62.27 25.73Q392-405.77 392-369.23q0 36.54 25.73 62.27 25.73 25.73 62.27 25.73ZM311.54-556.62h240.15q13.76 0 22.96-9.17 9.19-9.17 9.19-22.89v-59.52q0-13.72-9.19-23.07-9.2-9.34-22.96-9.34H311.54q-13.76 0-22.96 9.17-9.19 9.17-9.19 22.89v59.52q0 13.72 9.19 23.07 9.2 9.34 22.96 9.34ZM216-629v413-528 115Z"/>
                    </svg>
                </a>
                <a href="/dashboard/notes#" class="notes__edit [ js-edit-note ]" data-keep-id="12">
                    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000">
                        <path d="M238-396q-11.05 0-18.52-7.42-7.48-7.42-7.48-18.38 0-10.97 7.48-18.58Q226.95-448 238-448h236q11.05 0 18.53 7.42 7.47 7.42 7.47 18.38 0 10.97-7.47 18.58Q485.05-396 474-396H238Zm0-150q-11.05 0-18.52-7.42-7.48-7.42-7.48-18.38 0-10.97 7.48-18.58Q226.95-598 238-598h380q11.05 0 18.53 7.42 7.47 7.42 7.47 18.38 0 10.97-7.47 18.58Q629.05-546 618-546H238Zm0-150q-11.05 0-18.52-7.42-7.48-7.42-7.48-18.38 0-10.97 7.48-18.58Q226.95-748 238-748h380q11.05 0 18.53 7.42 7.47 7.42 7.47 18.38 0 10.97-7.47 18.58Q629.05-696 618-696H238Zm294.62 451.84v-50.89q0-6.63 2.61-12.25 2.62-5.62 7.23-10.24l196.31-195.31q5.72-5.87 12.24-8.2 6.52-2.33 12.93-2.33 6.99 0 13.56 2.53 6.58 2.54 11.96 7.62l44 45.38q5.05 5.72 7.79 12.29Q844-449 844-442.55t-2.53 13.11q-2.52 6.66-8.01 12.28L638.15-221.85q-4.61 4.62-10.23 7.23-5.63 2.62-12.26 2.62h-50.89q-13.67 0-22.91-9.25-9.24-9.24-9.24-22.91Zm275.69-198.15-45-45.38 45 45.38Zm-240 194.62h45l123.84-123.47-22.38-23-21.62-22.76-124.84 124.23v45Zm146.46-146.47-21.62-22.76 44 45.76-22.38-23Z"></path>
                    </svg>
                </a>
                <a href="#" class="notes__delete [ js-delete-note ]" data-keep-id="${note.keep_id}">
                    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000">
                        <path d="M324.31-164q-26.53 0-45.42-18.89T260-228.31V-696h-22q-11.05 0-18.52-7.42-7.48-7.42-7.48-18.38 0-10.97 7.48-18.58Q226.95-748 238-748h146v-12q0-12.99 9.2-22.19 9.19-9.19 22.18-9.19h129.24q12.99 0 22.18 9.19 9.2 9.2 9.2 22.19v12h146q11.05 0 18.52 7.42 7.48 7.42 7.48 18.38 0 10.97-7.48 18.58Q733.05-696 722-696h-22v467.26q0 27.26-18.89 46T635.69-164H324.31ZM648-696H312v467.69q0 5.39 3.46 8.85t8.85 3.46h311.38q5.39 0 8.85-3.46t3.46-8.85V-696ZM425.96-288q10.96 0 18.58-7.47 7.61-7.48 7.61-18.53v-284q0-11.05-7.41-18.53-7.42-7.47-18.39-7.47-10.96 0-18.58 7.47-7.61 7.48-7.61 18.53v284q0 11.05 7.41 18.53 7.42 7.47 18.39 7.47Zm107.69 0q10.96 0 18.58-7.47 7.61-7.48 7.61-18.53v-284q0-11.05-7.41-18.53-7.42-7.47-18.39-7.47-10.96 0-18.58 7.47-7.61 7.48-7.61 18.53v284q0 11.05 7.41 18.53 7.42 7.47 18.39 7.47ZM312-696v480-480Z" />
                    </svg>
                </a>
            </div>`
            });
            $notesList.innerHTML = notesHTML;
        }
    }


    let updateFavourite = (is_favourite) => {
        if (is_favourite) {
            if ($('.breadcrumbs .heart')) $('.breadcrumbs .heart').classList.add('hearted');
            if ($actionButton.querySelector('.heart')) $actionButton.querySelector('.heart').classList.add('hearted');
        }
    }

    API.fetch_keeps({ entity_id, entity_type })
        .then((response) => {
            if (response.message !== 401) {
                updateFavourite(response.data.favourite);
                renderNotes(response.data.notes);
            }
        });


    $notes.addEventListener('click', (e) => {

        if (e.target.classList.contains('js-notes-save')) {
            e.preventDefault();

            let content = $notes.querySelector('.js-notes-content').value;

            API.save_note({ entity_id, entity_type, content })
                .then((response) => {
                    $notes.querySelector('.js-notes-content').value = '';

                    Toast.fire({
                        icon: (response.status === 'ok') ? 'success' : 'error',
                        title: (response.message !== 401) ? response.message : 'You need to be logged in as a pro member to add notes'
                    });

                    API.fetch_keeps({ entity_id, entity_type })
                        .then((response) => renderNotes(response.data.notes));
                });

        }


        if (e.target.classList.contains('js-delete-note')) {
            e.preventDefault();
            let keep_id = e.target.dataset.keepId;

            Swal.fire({
                title: 'Delete note',
                text: 'Are you sure you want to delete this note?',
                icon: 'info',
                showCancelButton: true,
                cancelButtonText: 'Cancel',
                confirmButtonText: 'Delete'
            }).then((result) => {
                if (result.isConfirmed) {

                    API.delete_note({ keep_id, entity_id, entity_type })
                        .then((response) => {
                            $notes.querySelector('.js-notes-content').value = '';

                            Toast.fire({
                                icon: (response.status === 'ok') ? 'success' : 'error',
                                title: response.message
                            });

                            API.fetch_keeps({ entity_id, entity_type })
                                .then((response) => renderNotes(response.data.notes));
                        });
                }
            })

        }

    });


    if ($$showNotes) {
        $$showNotes.forEach($showNote => {
            $showNote.addEventListener('click', (e) => {
                e.preventDefault();
                $notes.classList.add('visible');
                $actionButton.classList.remove('active');
            });
        });
    }

    if ($$hideNotes) {
        $$hideNotes.forEach($hideNote => {
            $hideNote.addEventListener('click', (e) => {
                e.preventDefault();
                $notes.classList.remove('visible');
                $actionButton.classList.remove('active');
            });
        });
    }

}

document.body.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-edit-note')) {
        e.preventDefault();
        let $note = e.target.closest('.js-note');
        let $noteContent = $note.querySelector('.js-note-content');
        $note.classList.add('editing');
        $noteContent.setAttribute('contenteditable', true);
        $noteContent.focus();

        // Move caret to the end of contenteditable area
        let range = document.createRange();
        let selection = window.getSelection();
        range.selectNodeContents($noteContent);
        range.collapse(false);
        selection.removeAllRanges();
        selection.addRange(range);
    }
});

document.body.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-update-note')) {
        e.preventDefault();
        let $note = e.target.closest('.js-note');
        let entity_id = $note.dataset.entityId;
        let keep_id = $note.dataset.id;
        let entity_type = $note.dataset.type
        let content = $note.querySelector('.js-note-content').innerText;

        API.edit_note({ keep_id, entity_id, entity_type, content })
            .then((response) => {
                console.log(response);
                $note.classList.remove('editing');
                $note.querySelector('.js-note-content').setAttribute('contenteditable', false);

                Toast.fire({
                    icon: (response.status === 'ok') ? 'success' : 'error',
                    title: (response.message !== 401) ? response.message : 'You need to be logged in as a pro member to add notes'
                });
            });

    }
});